import { TestFunction } from 'yup';
import getRegexFromString from '../getRegexFromString';

const isValidRegex: TestFunction<string> = (value) => {
  const [error] = getRegexFromString(value);
  return !error;
};

export default isValidRegex;
